<template>
  <div class="card-form">
    <h3 class="mb-3">{{ "onboard.card.have_card.form.title" | trans }}</h3>

    <b-form @submit.prevent="onSubmit">
      <app-form-input
        type="tel"
        :length="8"
        v-model="form.number"
        :placeholder="$trans('ui.card_number')"
        variant="white"
        :error="errorMessages.number"
        autocomplete="off"
      />

      <app-form-checkbox
        v-model="form.terms"
        :error="errorMessages.terms"
        variant="white"
      >
        <div v-html="$trans('onboard.card.have_card.form.toc.label')"></div>
      </app-form-checkbox>

      <app-button
        :disabled="submitted"
        :loading="submitted"
        type="submit"
        size="lg"
        variant="light"
        block
        class="mt-4"
      >
        {{ "onboard.card.have_card.form.button.submit" | trans }}
      </app-button>
    </b-form>
  </div>
</template>

<script>
import AppFormInput from "@/components/form/FormInput";
import AppFormCheckbox from "@/components/form/FormCheckbox";
import { mapActions, mapGetters } from "vuex";
import { createValidationError, ValidationError } from "@/utils/validation";
import AppButton from "@/components/ui/Button";

export default {
  name: "AppAddCardForm",
  components: { AppButton, AppFormCheckbox, AppFormInput },
  computed: {
    ...mapGetters("customers", ["customer"]),
    formData() {
      return {
        id: this.form.id,
        number: this.form.number,
      };
    },
  },
  methods: {
    ...mapActions("cards", ["addCard"]),
    ...mapActions("customers", ["getCustomer"]),
    validateForm() {
      const errors = {};
      if (!this.form.terms) {
        errors.terms = this.$trans("validation.terms.not_blank");
      }

      if (!Object.keys(errors).length) {
        return;
      }

      throw new ValidationError(errors);
    },
    async onSubmit() {
      try {
        this.validateForm();
        this.submitted = true;
        this.resetErrorMessages();
        await this.addCard(this.formData);
        await this.getCustomer();
      } catch (e) {
        const ve = createValidationError(e);

        if (ve.errors.customer) {
          await this.getCustomer();
          return;
        }

        this.errorMessages.number = ve.errors.card || null;
        this.errorMessages.terms = ve.errors.terms || null;
      } finally {
        this.submitted = false;
      }
    },
    resetErrorMessages() {
      Object.keys(this.errorMessages).forEach(
        key => (this.errorMessages[key] = null)
      );
    },
  },
  watch: {
    customer: {
      handler(value) {
        this.form.id = value.id;
      },
      immediate: true,
    },
  },
  data() {
    return {
      submitted: false,
      form: {
        id: null,
        number: null,
        terms: false,
      },
      errorMessages: {
        number: null,
        terms: null,
      },
    };
  },
};
</script>
